import { MessageService } from '@wuitk/angular/components/notification';

import { AppointmentService } from './services/appointment.service';
import { BulkOperationComponent } from '../bulk-operation/component/bulk-operation.component';
import { BulkOperationPollingService } from '../bulk-operation/services/bulk-operation-polling.service';
import { BulkOperationReassignService } from '../bulk-operation/services/bulk-operation-reassign.service';
import { BulkOperationService } from '../bulk-operation/services/bulk-operation.service';
import { CurationService } from '../curation/services/curation.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardService } from './services/dashboard.service';
import { DashboardTabComponent } from './components/dashboard/dashboard-tabs/dashboard-tab.component';
import { DynamicSearchService } from './services/dynamic-search.service';
import { GenericErrorComponent } from './components/generic-error/generic-error.component';
import { PathwaysConfigurationService, PathwaysService } from '@ispm-client/modules/pathways/services';
import { PatientDashboardComponent } from './components/patient-dashboard/patient-dashboard.component';
import { PatientEffects } from '@ispm-client/modules/patient/store';
import { PatientService } from '@ispm-client/modules/patient/services/patient.service';
import {DynamicApiService} from "../export/services/dynamic-api.service";
import {EmrIntegrationService} from "@ispm/test/services/emr-integration.service";
import {ReactiveFormsModule} from "@angular/forms";
import {TestHeaderElementsComponent} from "@ispm/test/components/test-header-elements/test-header-elements.component";
import { PopupActionComponent } from './components/worklist/popup-action/popup-action.component';
import { PrefetchingService } from '@ispm/core/services/prefetching.service';
import { ResourceService } from './services/resource.service';
import { SimpleSearchService } from './services/simple-search.service';
import { TablelistDataHandlerService } from './services/tablelist-data-handler.service';
import { TablelistHandlerService } from './services/tablelist-handler.service';
import { TablelistService } from './services/tablelist.service';
import { TablelistStoreHandlerService } from './services/tablelist-store-handler.service';
import { TestListService } from './services/testlist.service';
import { ValuesetEditorComponent } from './components/valueset-editor/valueset-editor.component';
import { ValuesetService } from './services/valueset.service';
import { WorklistActionsComponent } from './components/worklist-actions/worklist-actions.component';
import { WorklistComponent } from './components/worklist/worklist.component';
import { WorklistItemComponent } from './components/worklist-item/worklist-item.component';
import { WorklistService } from './services/worklist.service';
import {ExportWorklistDataService} from "../export/services/export-worklist-data.service";
import {ExportWorklistDataPollingService} from "../export/services/export-worklist-data-polling.service";
import { DashboardHomeComponent } from '@ispm/migration/components/home-component/home.component';
import { CaseSearchComponent } from '@ispm/dashboard/components/case-search/case-search.component';

export const COMPONENTS = [
  WorklistComponent,
  WorklistActionsComponent,
  WorklistItemComponent,
  PatientDashboardComponent,
  ValuesetEditorComponent,
  GenericErrorComponent,
  DashboardComponent,
	  // DashboardHomeComponent,
	 // CaseSearchComponent,
  GenericErrorComponent,
  PopupActionComponent,
  DashboardTabComponent,
  BulkOperationComponent
];

export const SERVICES = [
  PatientEffects,
  PatientService,
  WorklistService,
  EmrIntegrationService,
  ResourceService,
  TablelistStoreHandlerService,
  TablelistService,
  TablelistHandlerService,
  DynamicApiService,
  TablelistDataHandlerService,
  TestListService,
  DynamicSearchService,
  DashboardService,
  PrefetchingService,
  PathwaysService,
  PathwaysConfigurationService,
  CurationService,
  AppointmentService,
  ValuesetService,
  MessageService,
  SimpleSearchService,
  BulkOperationService,
  BulkOperationPollingService,
  BulkOperationReassignService,
  ExportWorklistDataService,
  ExportWorklistDataPollingService
];
